export const ADD_PENDING_REQUESTS = 'ADD_PENDING_REQUESTS'
export const CLEAR_STATE = 'CLEAR_STATE'
export const SET_CAPABILITIES = 'SET_CAPABILITIES'
export const SET_COUNCIL = 'SET_COUNCIL'
export const SET_CURRENT_CLIENT = 'SET_CURRENT_CLIENT'
export const SET_CURRENT_EVENT = 'SET_CURRENT_EVENT'
export const SET_CURRENT_GUARD = 'SET_CURRENT_GUARD'
export const SET_CURRENT_MEETING = 'SET_CURRENT_MEETING'
export const SET_CURRENT_PERSON = 'SET_CURRENT_PERSON'
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE'
export const SET_CURRENT_RESOURCE = 'SET_CURRENT_RESOURCE'
export const SET_CURRENT_SHIFT = 'SET_CURRENT_SHIFT'
export const SET_CURRENT_SURVEY = 'SET_CURRENT_SURVEY'
export const SET_CURRENT_UNIT = 'SET_CURRENT_UNIT'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_CURRENT_VENUE = 'SET_CURRENT_VENUE'
export const SET_CURRENT_WORKPLACE = 'SET_CURRENT_WORKPLACE'
export const SET_IS_RESELLER = 'SET_IS_RESELLER'
export const SET_MENU = 'SET_MENU'
export const SET_MENU_ITEMS = 'SET_MENU_ITEMS'
export const SET_PERSON_ROLES = 'SET_PERSON_ROLES'
export const SET_POLLS = 'SET_POLLS'
export const SET_STATE = 'SET_STATE'
export const SET_SYSTEM_PARAMS = 'SET_SYSTEM_PARAMS'
export const SET_TASK = 'SET_TASK'
export const SET_USER_POLLS_READY = 'SET_USER_POLLS_READY'
export const SUB_PENDING_REQUESTS = 'SUB_PENDING_REQUESTS'
export const SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG'
export const SET_GUARD_NOTIFICATIONS = 'SET_GUARD_NOTIFICATIONS'
// chat
export const ADD_MESSAGE = 'ADD_MESSAGE'
export const ADD_HISTORY_MESSAGE = 'ADD_HISTORY_MESSAGE'
export const LOAD_AGENT_CONVERSATIONS = 'LOAD_AGENT_CONVERSATIONS'
export const LOAD_CONVERSATIONS = 'LOAD_CONVERSATIONS'
export const SET_AGENT = 'SET_AGENT'
export const SET_AGENT_CONNECTION = 'SET_AGENT_CONNECTION'
export const SET_CONVERSATIONS = 'SET_CONVERSATIONS'
export const SET_LOGING_IN_PROGRESS = 'SET_LOGING_IN_PROGRESS'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_HISTORY_MESSAGES = 'SET_HISTORY_MESSAGES'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SELECTED_CONVERSATION = 'SET_SELECTED_CONVERSATION'
export const LOAD_HISTORY_CONVERSATIONS = 'LOAD_HISTORY_CONVERSATIONS'
export const SET_HISTORY_CONVERSATIONS = 'SET_HISTORY_CONVERSATIONS'
